import { all } from "redux-saga/effects";
import productSaga from "./product-list";
import authSaga from "./auth";
import homeSaga from "./home";
import productDetailSaga from "./product-detail";
import myAccountSaga from "./my-account";
import cartSaga from "./cart";
import faqSaga from "./faq";
import partnerDetailsSaga from "./partner-details";
import externalContractSaga from "./external-contract";
import userSaga from "./user";
import notificationSaga from "./notification";
import reportsSaga from "./reports";
import engagementFormSaga from "./engagement-form";
import onboardingFormSaga from "./onboarding-form";
import notesSaga from "./notes";
import manageApplicationSaga from "./manage-application";
import globalLogsSaga from "./global-logs";
import partnerLogsSaga from "./partner-logs";
import partnerTierListSaga from "./partner-program";
import partnerLicenceListSaga from "./partner-program/licence-management";
import partnerRegionalMultiplierListSaga from "./partner-program/regional-multipliers";
import partnerEngagementConfigurationListSaga from "./partner-program/engagement-configuration";
import projectsSaga from "./projects";
import projectValidationSaga from "./project-validation";
import partnerProgramEventConfigurationListSaga from "./partner-program/calculator";
import chatbotSaga from "./chatbot";
import validationDocumentationSaga from "./validation-documentation";
import validationStatusSaga from "./validation-status";
import lookupDataSaga from "./lookup-data";
import partnerProgramBenefitsSaga from "./partner-program/benefits";
import benefitsLogSaga from "./partner-program/benefits-log";
import benefitActivityDashboardSaga from "./partner-program/benefit-activity-dashboard";
import featureManagementSaga from "./feature-management";
import integrationStatusSaga from "./integration-status";
import partnerDashboardSaga from "./partner-dashboard";
import adminHomeDashboardSaga from "./admin-home-dashboard";
import technologySettingsPhasesSaga from "./technology-settings/phases";
import technologySettingsTechnologiesSaga from "./technology-settings/technologies";

function* rootSaga() {
  try {
    yield all([
      authSaga(),
      homeSaga(),
      productSaga(),
      cartSaga(),
      productDetailSaga(),
      myAccountSaga(),
      faqSaga(),
      partnerDetailsSaga(),
      externalContractSaga(),
      userSaga(),
      notificationSaga(),
      reportsSaga(),
      engagementFormSaga(),
      onboardingFormSaga(),
      notesSaga(),
      manageApplicationSaga(),
      globalLogsSaga(),
      partnerLogsSaga(),
      partnerTierListSaga(),
      partnerLicenceListSaga(),
      partnerRegionalMultiplierListSaga(),
      partnerEngagementConfigurationListSaga(),
      projectsSaga(),
      projectValidationSaga(),
      partnerProgramEventConfigurationListSaga(),
      partnerProgramBenefitsSaga(),
      benefitsLogSaga(),
      benefitActivityDashboardSaga(),
      chatbotSaga(),
      validationDocumentationSaga(),
      validationStatusSaga(),
      lookupDataSaga(),
      featureManagementSaga(),
      integrationStatusSaga(),
      partnerDashboardSaga(),
      adminHomeDashboardSaga(),
      technologySettingsPhasesSaga(),
      technologySettingsTechnologiesSaga(),
    ]);
  } catch (e) {
    alert("Error in saga" +e);
  }
}

export default rootSaga;
